export const routes = {
  registrationForm: 'visitor-management/forms',
  visitorConfiguration: 'visitor-management/configuration',
  visitorLog: 'visitor-management/log',
  visitorPassDetails: 'visitor-management/visitorpass/:visitorPassId',
  recurrenceDetails: 'visitor-management/recurrencedetail/:recurrenceId',
  visitorWatchlist: 'visitor-management/watchlist',
  visitorWatchlistForm: 'visitor-management/watchlist/add',
  visitorWatchlistDetails: 'visitor-management/watchlist/details/:watchlistId',
  visitorCustomFieldCreate: 'visitor-management/configuration/custom-fields/new',
  visitorCustomFieldDetail: 'visitor-management/configuration/custom-fields/:customFieldId',
};
